import { accordionCloseIcon, accordionOpenIcon } from 'assets';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

 .dhtmlx-delete-popup {
    width: 640px;
    max-width: 100%;
    min-height: 190px;
    border-radius: 8px;
    background-color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    .dhtmlx_popup_title{
      width: 100%;
      color: #000000;
      font-size: 18px;
      letter-spacing: 0;
      border-bottom:unset;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 24px;
      padding-right: 23px;
      text-align: initial;
      line-height: initial;
    }
    .dhtmlx_popup_text{
      width: 100%;
      margin: 0;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      padding-left: 24px;
      min-height: 44px;
    }
    .dhtmlx_popup_controls{
      border-top: 1px solid rgba(0,0,0,0.05);
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction:row-reverse;
      min-height: 80px;
      padding-right: 24px;
      .gantt_popup_button{
          border-radius: 4px;
          background-color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content:center;
          height: 40px;
          min-width: 160px;
          font-size: 14px;
          letter-spacing: 0;
          line-height: 21px;
          margin: 0px 8px;
          &.dhtmlx_cancel_button{
           border: 1px solid #1C4B8C;
           color: #1C4B8C;
          }
          &.dhtmlx_ok_button{
            background: linear-gradient(149.45deg, #3C82C0 0%, #1C4B8C 100%);
            color: #FFFFFF;
          }
      }
      
    }
  }
`;
export type PropsGantt = {
  width?: string;
  height?: string;
  typeGroup?: boolean;
  type?: 'default' | 'group';
  boderDash?: boolean;
};

export type BoxChangeDateTimeProps = {
  className?: string;
  format?: string;
  onChangeDate?: (d: Date) => void;
  showIconDate?: boolean;
};

export const BoxChangeDateTime = styled.div<BoxChangeDateTimeProps>`
  .box-date {
    height: 24px;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .date-Picker {
    .icon-date {
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 18px;
        height: 20px;
        display: inline-block;
      }
    }
  }
  span.btn {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .text-date {
    display: flex;
    letter-spacing: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
`;

export const ContainerGantt = styled.section<PropsGantt>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  min-height: 256px;
  font-family: var(--font-family) !important;
  .gantt_task_row {
    border-bottom: 1px solid #d8d8d8;
    &.isWorktype {
      border-bottom: 1px solid #d8d8d8 !important;
    }
  }
  .gantt_task_line {
    background-color: unset;
    border: unset;
  }
  .gantt_cal_quick_info {
    width: 264px;
    border: unset;
    border-radius: 9px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    .gantt_cal_qi_content {
      padding-top: 32px;
      .title {
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
      }
      .content {
        color: #333333;
        font-size: 12px;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: 400;
      }
    }
    .gantt_cal_qi_controls {
      border-top: 1px solid #d8d8d8;
      padding: 8px 16px;
      display: inline-flex;
      width: 100%;
      justify-content: center;
      div {
        float: left;
        height: 24px;
        text-align: center;
        line-height: 24px;
      }
    }
    .gantt_qi_big_icon {
      width: 112px;
      padding: 0px;
      display: inline-block;
      margin: 0px 4px;
      border: 1px solid #1c4b8c;
      border-radius: 4px;
      background-color: #ffffff;
      color: #1c4b8c;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 21px;
      text-align: center;
      text-shadow: unset;
      background: unset;
      .gantt_menu_icon {
        display: none;
        .icon_delete {
          all: unset;
        }
      }
      div {
        &:not(.gantt_menu_icon) {
          width: 100%;
          font-size: 14px;
          letter-spacing: 0;
          text-align: center;
        }
      }
    }
    .gantt_cal_qi_title {
      padding: 0px;
      border-bottom: none;
      .quick_info_title {
        position: relative;
        .btn-close-quickinfo {
          position: absolute;
          top: 10px;
          right: 12px;
        }
      }
    }
  }

  .timeline_scale_cell_class {
    background-color: rgba(64, 144, 255, 0.05) !important;
  }
  .gantt_container,
  .gantt_tooltip {
    background-color: #fff;
    font-family: var(--font-family) !important;
  }
  .gantt_task_line_split_start {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
  .gantt_task_line_split_end {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .scales_date_time {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &.gantt-group {
    .scales_date_time {
      line-height: 16px;
      color: #000000 !important;
      font-size: 10px;
    }

    .gantt_row_task {
      .gantt_last_cell {
        border-left: 1px solid #f2f2f2 !important;
      }
    }

    .gantt_task_content {
      text-align: left;
      padding-left: 8px;
      width: calc(100% - 16px);
    }

    .gantt_task_line.gantt_bar_task {
      opacity: 1;
      border-radius: 8px;
      border-color: transparent;
    }

    .gantt_cell {
      padding-left: 8px;
      padding-right: 8px;
    }

    .active_scale_cell_class.scales_date_time {
      background-color: #2666bf;
      color: #ffffff !important;
    }

    .timeline_scale_cell_class {
      background-color: rgba(64, 144, 255, 0.05) !important;
    }

    .gantt_grid_head_cell {
      color: #333333 !important;
      font-size: 12px;
      text-align: left;
      padding-left: 8px;
      font-weight: 400;
    }

    .gantt_grid_head_cell:first-child {
      border-right: 1px solid rgba(0, 0, 0, 0.05) !important;
    }
    .gantt_task_line {
      background-color: #69b362;
      opacity: 1;
    }
    .primary {
      background-color: #69b362;
      opacity: 1;
    }
    .hidden {
      display: none;
    }
    .disable {
      background-color: #b2b2b2;
      opacity: 1;
    }
    .gantt_layout_cell_border_bottom {
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
    .gantt_layout_cell_border_left {
      border-left: 1px solid rgba(0, 0, 0, 0.05);
    }
    .gantt_grid_scale,
    .gantt_task_scale {
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
    .gantt_layout_cell_border_right {
      border-right: 1px solid rgba(0, 0, 0, 0.05);
    }
    .gantt_layout_cell_border_top {
      border-top: 1px solid rgba(0, 0, 0, 0.05);
    }
    .primary .gantt_task_content,
    .disable .gantt_task_content {
      color: #ffffff;
      font-size: 10px;
    }

    .gantt_grid_data .gantt_cell_tree {
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
    }

    .gantt_grid_data .gantt_tree_indent,
    .gantt_grid_data .gantt_tree_icon.gantt_blank,
    .gantt_grid_data .gantt_tree_icon.gantt_file {
      display: none;
    }

    .gantt_grid_data .gantt_tree_content {
      flex: 1;
      font-size: 12px;
      font-weight: 400;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .gantt_grid_data .gantt_row .gantt_cell + .gantt_grid_data .gantt_row .gantt_cell {
      border-left: 1px solid rgba(0, 0, 0, 0.05);
    }

    .gantt_grid_data .gantt_cell {
      /* border-right: 1px solid rgba(0, 0, 0, 0.05); */
    }

    .gantt_tree_icon.gantt_open {
      background-image: url(${accordionOpenIcon});
    }
    .gantt_split_parent,
    .gantt_split_subproject {
      opacity: 0;
      pointer-events: none;
      background-color: unset;
    }
    .gantt_tree_icon.gantt_close {
      background-image: url(${accordionCloseIcon});
    }

    .gantt_grid_data .gantt_row.odd:hover,
    .gantt_grid_data .gantt_row:hover {
      background-color: transparent;
    }
  }
  &.gantt {
    .weekend {
      background: unset;
    }

    .scales_date_time {
      line-height: 16px;
      color: #000000 !important;
      font-size: 10px;
    }
    .gantt_split_parent {
      display: none;
    }
    .gantt_task_content {
      text-align: left;
      padding-left: 8px;
      /* width: calc(100% - 36px); */
      .task-locale {
        display: flex;
        align-items: center;
        &:after {
          content: '';
          display: inline-flex;
          margin-left: 4px;
          margin-right: 4px;
          height: 10px;
          width: 1px;
          background-color: #ffffff;
        }
      }
    }

    .gantt_task_line.gantt_bar_task {
      border-radius: 8px;
      border-color: transparent;
    }

    .gantt_task_cell {
      background-image: linear-gradient(to bottom, #00000029 54%, rgba(255, 255, 255, 0) 0%);
      background-position: right;
      background-size: 1px 11px;
      background-repeat: repeat-y;
      border-right: unset;
      background-color: #f7f7f7;
    }

    .gantt_task_bg .gantt_task_row:not(:last-child) {
      border: none;
    }

    .gantt_task_bg .gantt_task_row._aaaa {
      border-bottom: 2px solid rgba(0, 0, 0, 0.05);
    }

    .active_scale_cell_class.scales_date_time {
      background-color: #2666bf;
      color: #ffffff !important;
    }

    .gantt_grid_head_cell[data-column-index~='0'] {
      display: flex;
      align-items: center;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 18px;
      padding-left: 7px;
      color: var(--black);
      .gantt_grid_label {
        padding-right: 8px;
        height: 100%;
        display: flex;
        align-items: center;
        white-space: pre-wrap;
        color: #333333;
        font-size: 12px;
        letter-spacing: 0;
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        width: calc(30% - 3px);
        min-width: 49px;
        display: inline-flex;
        justify-content: center;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: horizontal;
        overflow: hidden;
      }
      .gantt_grid_value {
        width: calc(100% - 48px);
        padding-left: 8px;
        line-height: 13px;
        height: 100%;
        white-space: pre-wrap;
        display: -webkit-box;
        justify-content: flex-start;
        text-align: left;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        display: flex;
        align-items: center;
      }
    }

    .primary {
      background-color: #69b362;
    }

    .disable {
      background-color: #b2b2b2;
    }

    .hidden {
      display: none;
    }

    .primary .gantt_task_content,
    .disable .gantt_task_content {
      color: #ffffff;
      font-size: 10px;
      letter-spacing: 0;
    }
    .gantt_task_drag {
      margin-top: 3px;
      width: 10px;
      height: 10px;
      /* background-color: #ffffff; */
      display: block;
      cursor: ew-resize;
      &.task_left {
        left: 0px;
      }
      &.task_right {
        right: 0px;
      }
    }
    .gantt_grid_head {
      color: #333333;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      .gantt_grid_value {
        width: calc(100% - 48px);
        padding-left: 8px;
        line-height: 32px;
        height: 100%;
        white-space: nowrap;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        align-items: center;
      }
      .gantt_grid_label {
        padding-right: 8px;
        height: 100%;
        align-items: center;
        white-space: nowrap;
        color: #333333;
        font-size: 12px;
        letter-spacing: 0;
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        width: 30%;
        min-width: 50px;
        justify-content: center;
        -webkit-line-clamp: 1;
        -webkit-box-orient: horizontal;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 32px;
      }
    }

    .gantt_tree_icon {
      /*visibility: hidden;*/
    }

    .gantt_grid_data .gantt_grid_separate {
      border-bottom-width: 0px;
    }

    .gantt_grid_data .gantt_grid_separate .gantt_cell {
      flex-direction: row-reverse;
    }

    .gantt_grid_data .gantt_grid_label {
      border-bottom: none;
    }

    .gantt_grid_data .gantt_grid_label .gantt_cell {
      flex-direction: row;
    }

    .gantt_grid_data .gantt_grid_label .gantt_grid_head {
      padding-left: 6px;
      color: #000000;
      font-size: 14px;
      line-height: 21px;
      display: flex;
      font-weight: 600;
      justify-content: flex-start;
      align-items: center;
      pointer-events: none;
    }

    .gantt_grid_data .gantt_grid_parent {
      display: flex;
      justify-content: space-between;
      flex: 1;
      padding-right: 6px;
      padding-left: 6px;
    }

    .gantt_grid_data .gantt_grid_group,
    .gantt_grid_data .gantt_grid_item {
      border-bottom: none;
    }

    .gantt_grid_data > .gantt_grid_default > .gantt_cell {
      flex-direction: row-reverse;
    }

    .gantt_task_row_separate {
      /* border-bottom: 2px solid #d8d8d8 !important; */
    }

    .gantt_grid_data .gantt_row.odd:hover,
    .gantt_grid_data .gantt_row:hover {
      background-color: unset;
    }

    .gantt_grid_data .gantt_grid_group,
    .gantt_task_bg .gantt_task_row_parent {
      border-top: 2px solid #d8d8d8 !important;
    }

    .gantt_task_bg .gantt_task_row_parent:first-child {
      border-top: none !important;
    }
  }
`;
